import { Checkbox as UICheckbox } from '@rocketlane/ui';
import styled from 'styled-components';
const StyledCheckbox = styled(UICheckbox)`
  &.rl-checkbox {
    height: 1rem;
    width: 1rem;
  }

  & + & {
    margin: 0;
  }
`;
const StyledCheckboxGroup = styled(UICheckbox.Group)``;
StyledCheckbox.Group = StyledCheckboxGroup;
export const Checkbox = StyledCheckbox;
